import React, { useEffect, useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Grid, Typography, Button, Divider, Dialog, DialogContent, IconButton } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CloseIcon from '@mui/icons-material/Close';
import { Modal as BootstrapModal } from "react-bootstrap";
import remove from "../../images/remove.png";
import greenCheck from "../../Icon/green-circle-check.png";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";

const FileUploadWithPreview = ({ flagRelation, setFiles, fileDescriptions, files, fileDescriptionsOption2, fileDescriptionsFlagY, fileDescriptionsIdnvYSelf, idnvFlag }) => {
    // const [files, setFiles] = useState(Array(fileDescriptions.length).fill(null));
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [completedModal, setCompletedModal] = useState(false);
    const [toggleImg, setToggleImg] = useState(false);
    const [textModal, setTextModal] = useState("");
    const allowedFileTypes = ["image/jpeg", "image/png", "application/pdf"];
    const allowedFileExtensions = [".jpeg", ".jpg", ".png", ".pdf"];



    useEffect(() => {
        // console.log(flagRelation)
    }, [flagRelation, setFiles])
    const onDrop = useCallback(
    (acceptedFiles, index) => {
      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
  
        if (
          !allowedFileTypes.includes(file.type) &&
          !allowedFileExtensions.some((ext) =>
            file.name.toLowerCase().endsWith(ext)
          )
        ) {
          const updatedFiles = [...files];
          updatedFiles[index] = null; 
          setFiles(updatedFiles);
  
          setTextModal(
            `ไฟล์ "${file.name}" ไม่สามารถอัพโหลดได้ (รองรับเฉพาะไฟล์ .jpeg, .jpg, .png, .pdf)`
          );
          setCompletedModal(true);
          return;
        }
  
        const updatedFiles = [...files];
        updatedFiles[index] = Object.assign(file, {
          preview: URL.createObjectURL(file),
        });
        setFiles(updatedFiles);
      }
    },
    [files]
  );


    const createDropzoneProps = (index) => {
        return useDropzone({
            onDrop: (acceptedFiles) => onDrop(acceptedFiles, index),
            accept: {
                "image/*": [],
                "application/pdf": [],
            },
            multiple: false,
        });
    };

    const handleClickOpen = (file) => {
        setSelectedFile(file);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedFile(null);
    };

    return (
        <div style={{ padding: 20 }}>
            {idnvFlag === "Y" ? (
                // แสดง Grid ตาม idnvFlag และ flagRelation
                // ถ้า flagRelation = true ใช้ fileDescriptionsFlagY (3 ไฟล์)
                // ถ้า flagRelation = false ใช้ fileDescriptionsIdnvYSelf (1 ไฟล์)
                <Grid container spacing={2}>
                    {(flagRelation ? fileDescriptionsFlagY : fileDescriptionsIdnvYSelf).map((description, index) => {
                        const { getRootProps, getInputProps } = createDropzoneProps(index);
                        return (
                            <Grid container spacing={1} key={index} style={{ marginBottom: '20px', fontFamily: "Prompt-Thin" }}>
                                {/* Description Section */}
                                <Grid item xs={12} md={10}>
                                    <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                                        {description}
                                        <span style={{ color: 'red', marginLeft: '4px' }}> *</span>

                                    </Typography>
                                    {index === 0 && (
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                            style={{ fontWeight: 'bold', color: 'red', cursor: 'pointer' }}
                                        >
                                            (หน้าบัตรที่มีเลขบัตรเครดิตและวันหมดอายุบัตร)
                                        </Typography>
                                    )}
                                    <Typography variant="body2" color="textSecondary">
                                        รองรับไฟล์ .jpeg, .png, .pdf
                                    </Typography>
                                </Grid>

                                {/* File Upload Button Section */}
                                <Grid item xs={12} md={2} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                    <div {...getRootProps()} style={{ cursor: 'pointer' }}>
                                        <input {...getInputProps()} />
                                        <Button
                                            variant="outlined"
                                            style={{
                                                borderRadius: '15px',
                                                padding: '8px 20px',
                                                boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.15)',
                                                textTransform: 'none',
                                                backgroundColor: '#f7f7f7',
                                                borderColor: '#cccccc',
                                                color: '#333333',
                                                fontSize: '16px',
                                                fontFamily: 'Prompt-Thin'
                                            }}
                                        >
                                            อัพโหลด
                                        </Button>
                                    </div>
                                </Grid>

                                {/* File Name Preview */}
                                <Grid item xs={12} md={10}>
                                    {files[index] && (
                                        <Typography
                                            variant="subtitle1"
                                            style={{ cursor: 'pointer', color: '#ff5e43', textDecoration: 'underline' }}
                                            onClick={() => handleClickOpen(files[index])}
                                        >
                                            {files[index].name}
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                        );
                    })}
                </Grid>
            ) : (
                // แสดง Grid ที่ใช้ fileDescriptions หรือ fileDescriptionsOption2 ตาม flagRelation เมื่อ idnvFlag เป็น "N"
                <Grid container spacing={2}>
                    {(flagRelation ? fileDescriptionsOption2 : fileDescriptions).map((description, index) => {
                        const { getRootProps, getInputProps } = createDropzoneProps(index);
                        return (
                            <Grid container spacing={1} key={index} style={{ marginBottom: '20px' }}>
                                {/* Description Section */}
                                <Grid item xs={12} md={10}>
                                    <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                                        {description}
                                        <span style={{ color: 'red', marginLeft: '4px' }}> *</span>
                                    </Typography>
                                    {index === 0 && (
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                            style={{ fontWeight: 'bold', color: 'red', cursor: 'pointer' }}
                                        >
                                            (หน้าบัตรที่มีเลขบัตรเครดิตและวันหมดอายุบัตร)
                                        </Typography>
                                    )}
                                    {index === 2 && !flagRelation && (
                                        <Typography
                                            component="a"
                                            href="https://rabbitlife-my.sharepoint.com/:i:/g/personal/saijai_s_rabbitlife_co_th/Ef_D2yj-LP9DtzcbhUNP_70BzGqtkwNUtdUve5O2HgSpBw"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            variant="body2"
                                            style={{ fontWeight: 'bold', color: 'red', cursor: 'pointer' }}
                                        >
                                            (ตัวอย่างเอกสาร)
                                        </Typography>
                                    )}
                                    <Typography variant="body2" color="textSecondary">
                                        รองรับไฟล์ .jpeg, .png, .pdf
                                    </Typography>
                                </Grid>

                                {/* File Upload Button Section */}
                                <Grid item xs={12} md={2} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                    <div {...getRootProps()} style={{ cursor: 'pointer' }}>
                                        <input {...getInputProps()} />
                                        <Button
                                            variant="outlined"
                                            style={{
                                                borderRadius: '15px',
                                                padding: '8px 20px',
                                                boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.15)',
                                                textTransform: 'none',
                                                backgroundColor: '#f7f7f7',
                                                borderColor: '#cccccc',
                                                color: '#333333',
                                                fontSize: '16px',
                                                fontFamily: 'Prompt-Thin'
                                            }}
                                        >
                                            อัพโหลด
                                        </Button>
                                    </div>
                                </Grid>

                                {/* File Name Preview */}
                                <Grid item xs={12} md={10}>
                                    {files[index] && (
                                        <Typography
                                            variant="subtitle1"
                                            style={{ cursor: 'pointer', color: '#ff5e43', textDecoration: 'underline' }}
                                            onClick={() => handleClickOpen(files[index])}
                                        >
                                            {files[index].name}
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                        );
                    })}
                </Grid>
            )}

            {/* Dialog for File Preview */}
            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
                <DialogContent>
                    <IconButton
                        style={{ position: 'absolute', right: 8, top: 8 }}
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </IconButton>
                    {selectedFile && selectedFile.type.startsWith('image/') && (
                        <img
                            src={selectedFile.preview}
                            alt={selectedFile.name}
                            style={{ width: '100%', height: 'auto' }}
                        />
                    )}
                    {selectedFile && selectedFile.type === 'application/pdf' && (
                        <object
                            data={selectedFile.preview}
                            type="application/pdf"
                            width="100%"
                            height="500px"
                        >
                            <p>PDF preview not available.</p>
                        </object>
                    )}
                </DialogContent>
            </Dialog>

            <BootstrapModal
        show={completedModal}
        backdrop="static"
        // size="md"
        // style={{}}
        className="backdrop-alert"
        contentClassName="modal-alert"
      >
        <BootstrapModal.Body>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={toggleImg ? greenCheck : remove}
              alt="check-icon"
              className="modal-image-size"
            />
          </div>

          <li
            className="body-list-group"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Col
              xl={12}
              md={12}
              xs={12}
              style={{
                display: "flex",
                marginTop: 5,
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <div className="font-modal">{textModal}</div>
            </Col>
          </li>
          <div className="d-flex justify-content-center flex-wrap">
            <button
              className="btn-checkout-modal w-20 p-2 bold"
              onClick={() => {
                if (toggleImg) {
                  navigate("/personal");
                } else {
                  setCompletedModal(false);
                }
              }}
            >
              กลับ
            </button>
          </div>
        </BootstrapModal.Body>
      </BootstrapModal>
        </div>
    );

};

export default FileUploadWithPreview;
